import { Switch as AntdSwitch } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Switch = ({
  label,
  required,
  className,
  labelClassName,
  switchClassName,
  size = "small",
  defaultChecked = false,
  ...props
}) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      {label && (
        <label
          className={classNames(styles.label, labelClassName, {
            [styles.labelRequired]: required,
          })}
        >
          {label}
        </label>
      )}
      <div className={styles.switchContainer}>
        <AntdSwitch
          size={size}
          className={classNames(styles.switch, switchClassName)}
          defaultChecked={defaultChecked}
          {...props}
        />
      </div>
    </div>
  );
};

export default Switch;
